import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { COLUMN_SELECTOR_CHECKBOX_ID } from '../dataset/column-selector/column-selector.component';
import { NgClass, NgIf } from '@angular/common';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { StudyEditorContext } from '../../study-editor.context';
import {
    GermplasmStudySourceFilter,
    GermplasmStudySourceModel,
    GermplasmStudySourceRequest,
    GermplasmStudySourceService
} from '../../../shared/germplasm/service/germplasm-study-source.service';
import { ColumnData } from '../../shared/models/column-data.model';
import { ColumnDataService } from '../../shared/services/column-data.service';
import { Principal } from '../../../shared';
import { JhiLanguageService } from '../../../shared/core-utils';
import { GermplasmDetailsPopupService } from '../../../germplasm-details/germplasm-details-popup.service';
import { AlertService } from '../../../shared/alert/alert.service';
import { LotCreationDialogComponent } from '../../../germplasm-manager/inventory/lot-creation-dialog.component';
import { InventoryDetailsPopupService } from '../../../germplasm-manager/inventory/details/inventory-details-popup.service';
import { CREATE_LOTS_PERMISSIONS, VIEW_GERMPLASM_DETAILS_PERMISSION, VIEW_NAMES_PERMISSIONS, VIEW_PEDIGREE_INFORMATION_PERMISSIONS } from '../../../shared/auth/permissions';
import { SubscriptionsManager } from '../../../shared/util/subscriptions-manager';
import { SearchOrigin } from '../../../shared/model/Search-origin-composite';
import { StudyEditorService } from '../../study-editor.service';
import { MAX_NAME_DISPLAY_SIZE } from '../../../app.constants';
import { preventDefaultOnShiftKey } from '../../../field-management/utils';
import {
    getStaticColumnLabelKey,
    STATIC_COLUMN_ACTIVE_LOT,
    STATIC_COLUMN_BREEDING_METHOD_ABBR, STATIC_COLUMN_BREEDING_METHOD_NAME, STATIC_COLUMN_BREEDING_METHOD_TYPE,
    STATIC_COLUMN_CROSS, STATIC_COLUMN_DESIGNATION,
    STATIC_COLUMN_GID,
    STATIC_COLUMN_GROUPGID,
    STATIC_COLUMN_BREEDING_LOCATION_NAME,
    STATIC_COLUMN_GERMPLASM_DATE
} from '../../../shared/util/static-columns-util';

@Component({
    selector: 'jhi-crosses-and-selections',
    templateUrl: './crosses-and-selections.component.html',
    styleUrl: './crosses-and-selections.component.scss'
})
export class CrossesAndSelectionsComponent implements OnInit, OnDestroy {

    public readonly MAX_NAME_DISPLAY_SIZE = MAX_NAME_DISPLAY_SIZE;
    protected readonly Math = Math;
    readonly STATIC_COLUMN_CHECKBOX = COLUMN_SELECTOR_CHECKBOX_ID;
    readonly ROW_NUMBER = 1;
    protected readonly STATIC_COLUMN_GID = STATIC_COLUMN_GID;
    protected readonly STATIC_COLUMN_GROUPGID = STATIC_COLUMN_GROUPGID;
    protected readonly STATIC_COLUMN_DESIGNATION = STATIC_COLUMN_DESIGNATION;
    protected readonly STATIC_COLUMN_CROSS = STATIC_COLUMN_CROSS;
    protected readonly STATIC_COLUMN_ACTIVE_LOT = STATIC_COLUMN_ACTIVE_LOT;
    protected readonly STATIC_COLUMN_BREEDING_METHOD_ABBR = STATIC_COLUMN_BREEDING_METHOD_ABBR;
    protected readonly STATIC_COLUMN_BREEDING_METHOD_NAME = STATIC_COLUMN_BREEDING_METHOD_NAME;
    protected readonly STATIC_COLUMN_BREEDING_METHOD_TYPE = STATIC_COLUMN_BREEDING_METHOD_TYPE;
    protected readonly STATIC_COLUMN_BREEDING_LOCATION_NAME = STATIC_COLUMN_BREEDING_LOCATION_NAME;
    protected readonly TRIAL_INSTANCE = 11;
    protected readonly PLOT_NUMBER = 12;
    protected readonly REPLICATION_NUMBER = 13;
    protected readonly STATIC_COLUMN_GERMPLASM_DATE = STATIC_COLUMN_GERMPLASM_DATE;
    protected readonly preventDefaultOnShiftKey = preventDefaultOnShiftKey;
    protected readonly getStaticColumnLabelKey = getStaticColumnLabelKey;

    @ViewChild('p', { static: false }) columnFilterPopover: NgbPopover;

    displayedColumns: ColumnData[] = [];
    entries: GermplasmStudySourceModel[] = [];

    selectedItems: Map<number, number> = new Map<number, number>();
    lastClickIndex: any;
    numberOfEntries = 0;
    numberOfFilteredEntries: number;
    currentPage = 1;
    pageSize = 50;

    isReloadPending: boolean;
    reloadTimeout: any;
    isTableDataReloadPending: boolean;
    tableDataReloadTimeout: any;
    reloadDelay: number = 800;
    isCategoricalDescriptionView = false;

    activePopover?: NgbPopover;
    columnDataForFilter: ColumnData;
    columnDataService: ColumnDataService;
    isSelectAll = false;

    hasCreateLotsPermission = true;
    hasViewGermplasmDetailsPermission = true;
    hasViewNamesPermission = true;
    hasViewPedigreePermission = true;

    subscriptionManager = new SubscriptionsManager();

    constructor(private jhiLanguageService: JhiLanguageService,
                private germplasmStudySourceService: GermplasmStudySourceService,
                private studyEditorContext: StudyEditorContext,
                public germplasmDetailsPopupService: GermplasmDetailsPopupService,
                private alertService: AlertService,
                private modalService: NgbModal,
                public inventoryDetailsPopupService: InventoryDetailsPopupService,
                public principal: Principal,
                private studyEditorService: StudyEditorService) {
    }

    ngOnDestroy(): void {
        this.subscriptionManager.unsubscribeAll();
    }

    ngOnInit(): void {

        this.columnDataService = new ColumnDataService(ColumnDataService.CROSSES_AND_SELECTIONS_TABLE_KEY, String(this.studyEditorContext.studyDetails.id));

        this.hasCreateLotsPermission = this.principal.hasAnyAuthorityDirect(CREATE_LOTS_PERMISSIONS);
        this.hasViewGermplasmDetailsPermission = this.principal.hasAnyAuthorityDirect(VIEW_GERMPLASM_DETAILS_PERMISSION);
        this.hasViewNamesPermission = this.principal.hasAnyAuthorityDirect(VIEW_NAMES_PERMISSIONS);
        this.hasViewPedigreePermission = this.principal.hasAnyAuthorityDirect(VIEW_PEDIGREE_INFORMATION_PERMISSIONS);

        this.loadTable();
    }

    /**
     * Efficiently reload table
     */
    scheduleReload(): void {
        if (this.isReloadPending) {
            // If a reload is already scheduled, reset the delay (debouncing)
            clearTimeout(this.reloadTimeout);
        } else {
            this.isReloadPending = true; // Indicate that a reload has been scheduled
        }

        // Schedule the reload after the specified delay
        this.reloadTimeout = setTimeout(() => {
            this.loadTable();
            this.isReloadPending = false; // Reset pending flag after reload
        }, this.reloadDelay);
    }

    /**
     * Efficiently reload table data
     */
    scheduleTableDataReload(pageIndex, pageSize): void {
        if (this.isTableDataReloadPending) {
            // If a reload is already scheduled, reset the delay (debouncing)
            clearTimeout(this.tableDataReloadTimeout);
        } else {
            this.isTableDataReloadPending = true; // Indicate that a reload has been scheduled
        }

        // Schedule the reload after the specified delay
        this.tableDataReloadTimeout = setTimeout(() => {
            this.loadTableData(pageIndex, pageSize);
            this.isTableDataReloadPending = false; // Reset pending flag after reload
        }, this.reloadDelay);
    }

    loadTable(): void {
        this.loadTableHeader();
        this.loadTableData();
    }

    createColumnData(id: number,displayName: string, visible: boolean, dataTypeCode?: 'NUMERIC_LIST' | 'TEXT' | undefined, name?: string): ColumnData  {
        return  {
            displayName: displayName,
            id: id,
            visible: visible,
            columnSelectorVisible: visible,
            selected: true,
            variableTypeId: 0,
            possibleValuesById: undefined,
            possibleValuesByName: undefined,
            enableFilterSorting: true,
            deletable: false,
            hidden: false,
            inputVariables: '',
            termId: id,
            name: name,
            alias: '',
            dataTypeCode: dataTypeCode
        };
    }

    loadTableHeader() {
        const columns: ColumnData[] = [
            this.createColumnData(this.STATIC_COLUMN_CHECKBOX, '', true,null,  'check'),
            this.createColumnData(this.ROW_NUMBER, '#', true, null, 'rowNumber'),
            this.createColumnData(this.STATIC_COLUMN_GID, 'GID', true, 'NUMERIC_LIST', 'gid'),
            this.createColumnData(this.STATIC_COLUMN_GROUPGID, 'GROUP ID', true, 'NUMERIC_LIST', 'groupId'),
            this.createColumnData(this.STATIC_COLUMN_DESIGNATION, 'DESIGNATION', this.hasViewNamesPermission,'TEXT', 'designation'),
            this.createColumnData(this.STATIC_COLUMN_CROSS, 'CROSS', (this.hasViewPedigreePermission && this.hasViewNamesPermission), 'TEXT', 'cross'),
            this.createColumnData(this.STATIC_COLUMN_ACTIVE_LOT, 'LOTS', true, 'NUMERIC_LIST', 'numberOfLots'),
            this.createColumnData(this.STATIC_COLUMN_BREEDING_METHOD_ABBR, 'BREEDING METHOD ABBREVIATION', true, 'TEXT', 'breedingMethodAbbreviation'),
            this.createColumnData(this.STATIC_COLUMN_BREEDING_METHOD_NAME, 'BREEDING METHOD NAME', true,'TEXT', 'breedingMethodName'),
            this.createColumnData(this.STATIC_COLUMN_BREEDING_METHOD_TYPE, 'BREEDING METHOD TYPE', true, 'TEXT', 'breedingMethodType'),
            this.createColumnData(this.STATIC_COLUMN_BREEDING_LOCATION_NAME, 'LOCATION', true,'TEXT', 'breedingLocationName'),
            this.createColumnData(this.TRIAL_INSTANCE, 'TRIAL_INSTANCE', true, 'NUMERIC_LIST', 'trialInstance'),
            this.createColumnData(this.PLOT_NUMBER, 'PLOT_NO', true, 'NUMERIC_LIST', 'plotNumber'),
            this.createColumnData(this.REPLICATION_NUMBER, 'REP_NO', true, 'NUMERIC_LIST', 'replicationNumber'),
            this.createColumnData(this.STATIC_COLUMN_GERMPLASM_DATE, 'GERMPLASM DATE', true, 'NUMERIC_LIST', 'germplasmDate')
        ];

        this.displayedColumns = this.columnDataService.displayedColumns = columns;
        this.displayedColumns = this.columnDataService.applyColumnsState();

    }

    onPageChange(page: number): void {
        this.currentPage = page;
        this.scheduleTableDataReload((page - 1), this.pageSize);
    }

    onPageSizeChange($event: Event) {
        this.scheduleTableDataReload((this.currentPage - 1), this.pageSize);
    }

    loadTableData(pageIndex = 0, pageSize = 50): void {
        const filter = this.getFilter();
        const sort = this.getSort();
        const searchData: GermplasmStudySourceRequest = {
            studyId: this.studyEditorContext.studyDetails.id,
            filter: filter
        };

        this.germplasmStudySourceService.searchGermplasmStudySources(this.studyEditorContext.studyDetails.id, searchData, pageIndex, this.pageSize, sort).toPromise()
            .then((paginatedResponse) => {
                this.entries = paginatedResponse.data;
                this.numberOfEntries = paginatedResponse.totalCount;
                this.numberOfFilteredEntries = paginatedResponse.filteredCount;
                this.studyEditorContext.germplasmListExists = this.numberOfEntries > 0;
                this.studyEditorContext.studyDetails.numberOfEntries = this.numberOfEntries;
            }
            );
    }

    trackRowsById(entry: GermplasmStudySourceModel) {
        return entry.germplasmStudySourceId;
    }

    getSort(): string {

        const sort = this.displayedColumns.reduce((sort, column) => {
            if (column.sortingAsc !== null && column.sortingAsc !== undefined) {
                return column.name + ',' + (column.sortingAsc ? 'asc' : 'desc');
            }
            return sort;
        }, '');

        return sort;
    }

    getFilter(): GermplasmStudySourceFilter {

        const filter: GermplasmStudySourceFilter = {
            germplasmStudySourceId: null,
            gidList: [],
            groupIdList: [],
            designation: null,
            cross: null,
            numberOfLotsList: [],
            breedingMethodAbbreviation: null,
            breedingMethodName: null,
            breedingMethodType: null,
            breedingLocationName: null,
            trialInstanceList: [],
            plotNumberList: [],
            replicationNumberList: [],
            germplasmDateList: [],
        };

        this.displayedColumns.forEach(column => {
            if (column.isFiltered) {
                if (column.id === this.STATIC_COLUMN_GID) {
                    filter.gidList = CrossesAndSelectionsComponent.toNumberArray(column.query.split(','));
                }
                if (column.id === this.STATIC_COLUMN_GROUPGID) {
                    filter.groupIdList = CrossesAndSelectionsComponent.toNumberArray(column.query.split(','));
                }
                if (column.id === this.STATIC_COLUMN_DESIGNATION) {
                    filter.designation = column.query;
                }
                if (column.id === this.STATIC_COLUMN_CROSS) {
                    filter.cross = column.query;
                }
                if (column.id === this.STATIC_COLUMN_ACTIVE_LOT) {
                    filter.numberOfLotsList = CrossesAndSelectionsComponent.toNumberArray(column.query.split(','));
                }
                if (column.id === this.STATIC_COLUMN_BREEDING_METHOD_ABBR) {
                    filter.breedingMethodAbbreviation = column.query;
                }
                if (column.id === this.STATIC_COLUMN_BREEDING_METHOD_NAME) {
                    filter.breedingMethodName = column.query;
                }
                if (column.id === this.STATIC_COLUMN_BREEDING_METHOD_TYPE) {
                    filter.breedingMethodType = column.query;
                }
                if (column.id === this.STATIC_COLUMN_BREEDING_LOCATION_NAME) {
                    filter.breedingLocationName = column.query;
                }
                if (column.id === this.TRIAL_INSTANCE) {
                    filter.trialInstanceList = column.query.split(',');
                }
                if (column.id === this.PLOT_NUMBER) {
                    filter.plotNumberList = CrossesAndSelectionsComponent.toNumberArray(column.query.split(','));
                }
                if (column.id === this.REPLICATION_NUMBER) {
                    filter.replicationNumberList = CrossesAndSelectionsComponent.toNumberArray(column.query.split(','));
                }
                if (column.id === this.STATIC_COLUMN_GERMPLASM_DATE) {
                    filter.germplasmDateList = CrossesAndSelectionsComponent.toNumberArray(column.query.split(','));
                }
            }
        });

        return filter;
    }

    clearSelected() {
        this.selectedItems.clear();
    }

    selectAll(isSelectAll) {
        this.isSelectAll = isSelectAll;
        // Hide the checkbox column when select all is true
        if (isSelectAll) {
            this.displayedColumns.find(column => column.id === this.STATIC_COLUMN_CHECKBOX).selected = false;
        } else {
            this.displayedColumns.find(column => column.id === this.STATIC_COLUMN_CHECKBOX).selected = true;
        }
        if (this.isSelectAll) {
            this.clearSelected();
        }
    }

    isSelected(germplasmStudySourceId: number): boolean {
        return this.selectedItems.has(germplasmStudySourceId) || this.isSelectAll;
    }

    toggleSelect($event, index: number, germplasmStudySource: GermplasmStudySourceModel, checkbox = false) {

        if (this.isSelectAll) {
            return;
        }

        if ($event.ctrlKey || $event.metaKey) {
            $event.preventDefault();
        }

        if (!checkbox) {
            $event.preventDefault();
        }

        if (!$event.ctrlKey && !$event.metaKey && !checkbox) {
            this.selectedItems.clear();
        }

        let items: GermplasmStudySourceModel[] = [];
        if ($event.shiftKey) {
            const max = Math.max(this.lastClickIndex, index) + 1;
            const min = Math.min(this.lastClickIndex, index);
            items = this.entries.slice(min, max);
        } else {
            items = [germplasmStudySource];
            this.lastClickIndex = index;
        }

        const isClickedItemSelected = this.selectedItems.has(germplasmStudySource.germplasmStudySourceId);
        for (const item of items) {
            if (isClickedItemSelected) {
                this.selectedItems.delete(item.germplasmStudySourceId);
            } else {
                this.selectedItems.set(item.germplasmStudySourceId, item.gid);
            }
        }
    }

    trackColumnsById(column: ColumnData) {
        return column.id;
    }

    // Filters

    showColumnFilterPopover(column: ColumnData, p: NgbPopover) {
        this.columnDataForFilter = column;
        p.open({
            column: column
        });
    }

    sortColumn(column: ColumnData, ascending: boolean): void {

        // Clear sorting state for all displayed columns to ensure only one column can be sorted at a time
        this.resetSortingsOfDisplayedColumns();

        column.sortingAsc = ascending;
        this.scheduleTableDataReload((this.currentPage - 1), this.pageSize);
    }

    filterByColumn(column: ColumnData) {
        this.clearSelected();
        column.isFiltered = true;
        this.columnFilterPopover.close();
        this.scheduleTableDataReload((this.currentPage - 1), this.pageSize);
    }

    resetFilterByColumn(column: ColumnData) {
        this.clearSelected();
        column.isFiltered = false;
        column.query = '';
        column.sortingAsc = null;
        column.possibleValues?.forEach(value => {
            value.isSelectedInFilters = false;
        });
        column.isSelectAll = false;
        this.scheduleTableDataReload((this.currentPage - 1), this.pageSize);
    }

    resetSortingsOfDisplayedColumns() {
        this.displayedColumns.forEach(column => {
            column.sortingAsc = null;
        });
    }

    filterSelectAll(column: ColumnData, isSelectAll: boolean) {
        if (column.possibleValues) {
            column.possibleValues.forEach(value => {
                value.isSelectedInFilters = isSelectAll;
            });
        }
    }

    openLotCreationModal() {
        if (!this.validateSelection()) {
            return;
        }

        const request: GermplasmStudySourceRequest = {
            studyId: this.studyEditorContext.studyDetails.id,
            filter: null
        };
        if (this.isSelectAll) {
            request.filter = this.getFilter();
        } else {
            const filter: GermplasmStudySourceFilter = {
                germplasmStudySourceId: null,
                gidList: [],
                groupIdList: [],
                designation: null,
                cross: null,
                numberOfLotsList: [],
                breedingMethodAbbreviation: null,
                breedingMethodName: null,
                breedingMethodType: null,
                breedingLocationName: null,
                trialInstanceList: [],
                plotNumberList: [],
                replicationNumberList: [],
                germplasmDateList: [],
            };
            filter.gidList = Array.from(this.selectedItems.values());
            request.filter = filter;
        }

        this.germplasmStudySourceService.saveSearchRequest(this.studyEditorContext.studyId, request).toPromise().then((searchDto) => {

            const modalRef = this.modalService.open(LotCreationDialogComponent as Component, { size: 'lg', backdrop: 'static' });
            modalRef.componentInstance.searchRequestId =  searchDto.searchResultDbId;
            modalRef.componentInstance.openedFromWorkbench = true;
            modalRef.componentInstance.searchOrigin = SearchOrigin.MANAGE_STUDY_SOURCE;
            modalRef.componentInstance.initialDepositRequired = true;
            modalRef.componentInstance.showReuseSrcObsUnitToggle = true;
            modalRef.result.then((result) => {
                this.studyEditorService.triggerRefreshAndWait().then(() => {
                    this.studyEditorService.navigateToTab(this.studyEditorContext.studyId, 'inventory');
                });
            });
        });

    };

    validateSelection() {
        if (this.selectedItems.size === 0 && !this.isSelectAll) {
            this.alertService.error('study-editor.crosses-and-selections.no-germplasm-error');
            return false;
        }
        return true;
    }

    private static toNumberArray(list: string[]) {
        if (list) {
            return list.map((item) => {
                return parseInt(item, 10);
            });
        }
        return [];
    }

    isApplyAllEnabled(columnDataForFilter: ColumnData): boolean {
        if (columnDataForFilter.query) {
            if (columnDataForFilter.dataTypeCode === 'NUMERIC_LIST') {
                const list = CrossesAndSelectionsComponent.toNumberArray(columnDataForFilter.query.split(','));
                return list.length > 0;
            } else {
                return true;
            }
        }
        return false;
    }

    onColumnSelectorDeselectedAll() {
        this.displayedColumns.forEach(column => {
            if (column.visible) {
                column.selected = false;
            }
        });
    }

    onColumnSelectorSelectedAll() {
        this.displayedColumns.forEach(column => {
            if (column.visible) {
                column.selected = true;
            }
        });
    }

    onColumnSelectorReset() {
        this.onColumnSelectorSelectedAll();
        this.scheduleReload();
    }

    clearFilters() {
        this.clearSelected();
        this.displayedColumns.forEach(column => {
            this.resetFilterByColumn(column);
        });
    }

    protected onSelectPage() {
        if (this.isPageSelected()) {
            // remove all items
            this.entries.forEach((item) => this.selectedItems.delete(item.germplasmStudySourceId));
        } else {
            // check remaining items
            this.entries.forEach((item) => this.selectedItems.set(item.germplasmStudySourceId, item.gid));
        }
    }

    protected isPageSelected() {
        return this.selectedItems && this.selectedItems.size && this.entries.every((item) => this.selectedItems.has(item.germplasmStudySourceId));
    }
}



